import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import type { updateUserEmailInput } from '#src/__generated__/globalTypes.ts';
import { walletRecovery } from '#src/contexts/currentUser/queries.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  UpdateUserEmailMutation,
  UpdateUserEmailMutationVariables,
} from './__generated__/useUpdateUserEmail.graphql.ts';

const UPDATE_EMAIL_MUTATION = gql`
  mutation UpdateUserEmailMutation($input: updateUserEmailInput!) {
    updateUserEmail(input: $input) {
      currentUser {
        slug
        unconfirmedEmail
        ...CurrentUserProvider_walletRecovery
      }
      errors {
        path
        message
        code
      }
    }
  }
  ${walletRecovery}
` as TypedDocumentNode<
  UpdateUserEmailMutation,
  UpdateUserEmailMutationVariables
>;

export const useUpdateUserEmail = () => {
  const [mutate] = useMutation(UPDATE_EMAIL_MUTATION, {
    showErrorsWithSnackNotification: false,
    sendErrors: true,
  });

  return useCallback(
    async (input: updateUserEmailInput) => {
      const { data } = await mutate({
        variables: {
          input,
        },
      });

      return data?.updateUserEmail || null;
    },
    [mutate]
  );
};
